module.exports = __webpack_public_path__ + "static/media/lock.53511394.svg";